import type { CommunityContentBlock } from '../types'

export type CopyDraft = { text: string; links: CommunityContentBlock[] }

export function copyDraft(blocks: CommunityContentBlock[]): CopyDraft {
  const links: CommunityContentBlock[] = []
  const text = blocks.map(block => {
    if (block.type === 'text') return block.text
    links.push({ ...block })
    return `【链接${links.length}】`
  }).join('\n')
  return { text, links }
}

export function copyBlocks(draft: CopyDraft): CommunityContentBlock[] {
  return draft.text.replace(/\r\n/g, '\n').split('\n').map(text => {
    const match = /^【链接([1-9]\d*)】$/.exec(text.trim())
    const link = match ? draft.links[Number(match[1]) - 1] : undefined
    return link ? { ...link } : { type: 'text', text }
  })
}
